var _path, _circle, _circle2, _circle3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "fi-rr-calendar",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.272,
    height: 18.272,
    viewBox: "0 0 18.272 18.272",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_5277",
    "data-name": "Path 5277",
    d: "M14.466,1.523H13.7V.761a.761.761,0,0,0-1.523,0v.761H6.091V.761a.761.761,0,1,0-1.523,0v.761H3.807A3.811,3.811,0,0,0,0,5.329v9.136a3.811,3.811,0,0,0,3.807,3.807H14.466a3.811,3.811,0,0,0,3.807-3.807V5.329A3.811,3.811,0,0,0,14.466,1.523ZM1.523,5.329A2.284,2.284,0,0,1,3.807,3.045H14.466A2.284,2.284,0,0,1,16.75,5.329v.761H1.523ZM14.466,16.75H3.807a2.284,2.284,0,0,1-2.284-2.284V7.613H16.75v6.852A2.284,2.284,0,0,1,14.466,16.75Z",
    fill: "#bbc6d1"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_391",
    "data-name": "Ellipse 391",
    cx: 1.142,
    cy: 1.142,
    r: 1.142,
    transform: "translate(7.994 10.278)",
    fill: "#bbc6d1"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_392",
    "data-name": "Ellipse 392",
    cx: 1.142,
    cy: 1.142,
    r: 1.142,
    transform: "translate(4.187 10.278)",
    fill: "#bbc6d1"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_393",
    "data-name": "Ellipse 393",
    cx: 1.142,
    cy: 1.142,
    r: 1.142,
    transform: "translate(11.801 10.278)",
    fill: "#bbc6d1"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.8f20c1f4.svg";
export { ForwardRef as ReactComponent };